/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingupaccount2Inputs */

const en_settingupaccount2 = /** @type {(inputs: Settingupaccount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setting up account...`)
};

const de_settingupaccount2 = /** @type {(inputs: Settingupaccount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richte Konto ein…`)
};

/**
* | output |
* | --- |
* | "Setting up account..." |
*
* @param {Settingupaccount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const settingupaccount2 = /** @type {((inputs?: Settingupaccount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingupaccount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settingupaccount2(inputs)
	return de_settingupaccount2(inputs)
});
export { settingupaccount2 as "settingUpAccount" }